import React from 'react';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import ExploreMoreTierUpsell from './ExploreMoreTierUpsell';
import WantMoreSubscribersTierUpsell from './WantMoreSubscribersTierUpsell';
export const TierUpsell = ({ className, deviation })=>{
    var _deviation_author;
    const { tier, isOwner, isUserSubscribed } = useSubscriptionTier(deviation);
    if (!tier || isUserSubscribed) {
        return null;
    }
    if (isOwner) {
        return /*#__PURE__*/ React.createElement(WantMoreSubscribersTierUpsell, {
            className: className
        });
    }
    return /*#__PURE__*/ React.createElement(ExploreMoreTierUpsell, {
        className: className,
        authorName: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username
    });
};
TierUpsell.displayName = 'TierUpsell';
export default TierUpsell;

//# sourceMappingURL=TierUpsell.js.map